"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "LegendContext", {
  enumerable: true,
  get: function get() {
    return _legendContext["default"];
  }
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _find = _interopRequireDefault(require("lodash/find"));
var _legendContext = _interopRequireDefault(require("./_legend-context"));
var _useDataVisualization2 = _interopRequireDefault(require("../_use-data-visualization"));
var _clampIndex = _interopRequireDefault(require("./../_utils/clamp-index"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// Do a *relatively* shallow merge (2 level deeps) of 2 objects.
var prettyShallowMerge = function prettyShallowMerge(a, b) {
  var result = _objectSpread({}, a);
  for (var key in b) {
    if ((0, _typeof2["default"])(b[key]) === "object" && (0, _typeof2["default"])(result[key]) === "object") {
      result[key] = _objectSpread(_objectSpread({}, result[key]), b[key]);
    } else {
      result[key] = b[key];
    }
  }
  return result;
};

/**
 * This component provides context for a data visualization + legend lockup.
 * Wrap a compatible data visualization along with the `Legend` component inside
 * this component and then pass things like the visualization's data, colors,
 * and labels to this component instead of the data visualization.
 */
var LegendProvider = function LegendProvider(props) {
  var id = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("mdn-legend-");
  }, []);
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hoverKey = _useState2[0],
    setHover = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    focusKey = _useState4[0],
    setFocus = _useState4[1];
  var _useDataVisualization = (0, _useDataVisualization2["default"])(props),
    data = _useDataVisualization.data,
    supplementalItems = _useDataVisualization.supplementalItems;
  // Returns a legend item given its key
  var getItem = (0, _react.useCallback)(function (key) {
    return (0, _find["default"])(data, ["key", key]);
  }, [data]);
  // Returns true if the legend item at the provided id is focused
  var getFocus = (0, _react.useCallback)(function (key) {
    return key === focusKey;
  }, [focusKey]);
  // Returns the current state of a legend item given the index of the item.
  var getState = (0, _react.useCallback)(function (key) {
    return key === focusKey ? "active" : focusKey === undefined && hoverKey === key ? "active" : hoverKey === undefined && focusKey === undefined ? "default" : "inactive";
  }, [hoverKey, focusKey]);
  // This should be called when the legend receives focus.
  var onFocus = (0, _react.useCallback)(function () {
    return focusKey === undefined && data.length > 0 && setFocus(data[0].key);
  }, [focusKey, data]);
  // This should be called when the legend is blurred.
  var onBlur = (0, _react.useCallback)(function () {
    return setFocus();
  }, []);
  // This should be called when the legend receives a key-press.
  var onKeyDown = (0, _react.useCallback)(function (event) {
    var key = event.key;
    var item = getItem(focusKey);
    if (item) {
      var focusIndex = item.index;
      // Navigate to the next/previous item when pressing a directional key
      if (key === "ArrowDown" || key === "ArrowRight") {
        setFocus(data[(0, _clampIndex["default"])(focusIndex + 1, data.length)].key);
        event.preventDefault();
      } else if (key === "ArrowUp" || key === "ArrowLeft") {
        setFocus(data[(0, _clampIndex["default"])(focusIndex - 1, data.length)].key);
        event.preventDefault();
      }
      // On space/enter press, "click" the item if it has a click handler
      else if ((key === " " || key === "Enter") && item.onClick) {
        item.onClick(item);
      }
    }
  }, [data, focusKey, getItem]);
  var legendContext = {
    id: id,
    data: data,
    focusKey: focusKey,
    setHover: setHover,
    setFocus: setFocus,
    getFocus: getFocus,
    getState: getState,
    getItem: getItem,
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    supplementalItems: supplementalItems,
    colorScale: props.colorScale,
    "aria-label": props["aria-label"],
    // The aria-label and aria-labelledby/describedby attributes tend to conflict.
    // If aria-label is provided then ignore aria-labelledby/describedby
    "aria-labelledby": props["aria-label"] ? undefined : props["aria-labelledby"],
    "aria-describedby": props["aria-label"] ? undefined : props["aria-describedby"]
  };
  // Plugins may call hooks, so this the plugins and their order shouldn't
  // change after mounting. We don't want to memoize it though, or the user
  // can't change the options that they pass to plugins.
  var pluginOutput = props.plugins.map(function (plugin) {
    return plugin(legendContext);
  }).reduce(function (result, _ref) {
    var _ref$_context = _ref._context,
      _context = _ref$_context === void 0 ? {} : _ref$_context,
      _ref$api = _ref.api,
      api = _ref$api === void 0 ? {} : _ref$api,
      _ref$_elements = _ref._elements,
      _elements = _ref$_elements === void 0 ? [] : _ref$_elements;
    return {
      _context: prettyShallowMerge(result._context, _context),
      _elements: result._elements.concat(_elements),
      api: prettyShallowMerge(result.api, api)
    };
  }, {
    _context: {},
    _elements: [],
    api: {}
  });
  // Mix the context generated by the plugin with the legend context
  var context = _objectSpread(_objectSpread({}, legendContext), pluginOutput._context);
  return /*#__PURE__*/_react["default"].createElement(_legendContext["default"].Provider, {
    value: context
  }, typeof props.children === "function" ? props.children(pluginOutput.api) : props.children, pluginOutput._elements);
};
LegendProvider.displayName = "LegendProvider";
LegendProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The LegendProvider should contain a compatible data visualization component
   * such as `Pie` or `Sparkline` along with a `Legend` component. Other
   * components such as layout components to help position the legend and
   * visualization are acceptable.
   *
   * If a plugin is provided via the `plugin` prop then a function can be passed
   * here. The arguments passed to the function are determined by the plugin
   * used.
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]).isRequired,
  /**
   * An array of data for the visualization. Each item in the array must be an
   * object with a value field containing the value of that item in the
   * visualization.
   *
   * A unique `key` field should also be provided if the data objects may change
   * after the component is mounted (this field will be used as the item's React
   * key).
   *
   * Each item will default to using a circle as its symbol. To customize, pass
   * the name of a predefined symbol as a string (e.g. "diamond") or a custom
   * component. Custom symbols will be passed the `color` as a prop.
   *
   * Set the item's `showInLegend` value to `false` to hide an item in the
   * legend. __NOTE__: this will effectively remove access to the item and
   * underlying data from keyboard-only users. Be sure to provide another point
   * of access to the data for keyboard-only users.
   */
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string.isRequired,
    color: _propTypes["default"].string,
    symbol: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["circle", "diamond", "square", "triangleDown", "triangleUp"]), _propTypes["default"].func]),
    label: _propTypes["default"].string,
    showInLegend: _propTypes["default"].bool
  })).isRequired,
  /**
   * The id of an element that acts as a description for the visualization.
   * We recommend displaying a Text component with a description for
   * the visualization and setting this prop to the id of that Text. This
   * prop will be ignored if aria-label is set.
   */
  "aria-describedby": _propTypes["default"].string,
  /**
   * A label for the visualization. We recommend using `aria-labelledby` if
   * possible if there is a visible element that labels the visualization. If
   * there is not a visible element that labels the visualization, or if you
   * want to provide a more descriptive label for screen-readers, use this prop.
   */
  "aria-label": _propTypes["default"].string,
  /**
   * The id of an element that acts as a label, heading, or title for the
   * visualization. We recommend displaying a Heading component with a title for
   * the visualization and setting this prop to the id of that Heading. This
   * prop will be ignored if aria-label is set.
   */
  "aria-labelledby": _propTypes["default"].string,
  /**
   * An array of colors to use in the visualization. The colors will be assigned
   * to data items according to their order in the array. If there are more data
   * items than colors then colors will be reused (also according to their order
   * in the array).
   *
   * If a color is defined for a data item via the `color` field in the item's
   * object then this color scale will be ignored for that item.
   */
  colorScale: _propTypes["default"].arrayOf(_propTypes["default"].string),
  /**
   * Pass a list of plugins via this prop to help integrate the legend with a
   * third-party charting solution.
   *
   * Important: Do not change the plugins in this list or their order after
   * mounting, otherwise things will not go well for your chart.
   */
  plugins: _propTypes["default"].array,
  /**
   * __NOTE__: Only use this prop to create _supplemental_ items. Use the `data`
   * prop to create items that interact with the visualization (i.e. focusing
   * on a Legend item highlights the relevant piece of data in the visualization).
   *
   * A unique `key` field should also be provided if the data objects may change
   * after the component is mounted (this field will be used as the item's React
   * key).
   *
   * Each item will default to using a circle as its symbol. To customize, pass
   * the name of a predefined symbol as a string (e.g. "diamond") or a custom
   * component. Custom symbols will be passed the `color` as a prop.
   */
  supplementalItems: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    key: _propTypes["default"].string,
    color: _propTypes["default"].string,
    symbol: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(["circle", "diamond", "square", "triangleDown", "triangleUp"]), _propTypes["default"].func])
  }))
} : {};
LegendProvider.defaultProps = {
  plugins: []
};
var _default = LegendProvider;
exports["default"] = _default;